module.exports = __webpack_public_path__ + "static/media/theme.18738c51.png";